export const REPORTS_TAB_IDS = {
  monthlyReports: 'monthlyReports',
  goodsInTransit: 'goodsInTransit',
  costsPaymentStatus: 'costsPaymentStatus',
  intrastatExport: 'intrastatExport',
  salesByUser: 'salesByUser',
  atRiskOrders: 'atRiskOrders',
  settlements: 'settlements',
} as const;

export type ReportsTabId = typeof REPORTS_TAB_IDS[keyof typeof REPORTS_TAB_IDS];

export interface ReportsTabDefinition {
  id: ReportsTabId;
  key: string;
  labelKey: string;
  currentAccess: 'financial';
  backendGate?: 'financialReports' | 'purchaseInvoices';
  endpoint?: string;
  exposesFinancialFields: boolean;
  futureOperationalCandidate?: boolean;
}

export const REPORTS_TAB_DEFINITIONS: ReportsTabDefinition[] = [
  {
    id: REPORTS_TAB_IDS.monthlyReports,
    key: '1',
    labelKey: 'reports:tabs.monthlyReports',
    currentAccess: 'financial',
    backendGate: 'financialReports',
    endpoint: '/reports/monthly-profit',
    exposesFinancialFields: true,
  },
  {
    id: REPORTS_TAB_IDS.goodsInTransit,
    key: '2',
    labelKey: 'reports:tabs.goodsInTransit',
    currentAccess: 'financial',
    backendGate: 'financialReports',
    endpoint: '/reports/goods-in-transit',
    exposesFinancialFields: true,
    futureOperationalCandidate: true,
  },
  {
    id: REPORTS_TAB_IDS.costsPaymentStatus,
    key: '3',
    labelKey: 'reports:tabs.costsPaymentStatus',
    currentAccess: 'financial',
    backendGate: 'purchaseInvoices',
    endpoint: '/reports/costs-payment-status',
    exposesFinancialFields: true,
  },
  {
    id: REPORTS_TAB_IDS.intrastatExport,
    key: '4',
    labelKey: 'reports:tabs.intrastatExport',
    currentAccess: 'financial',
    backendGate: 'financialReports',
    endpoint: '/intrastat/export',
    exposesFinancialFields: false,
  },
  {
    id: REPORTS_TAB_IDS.salesByUser,
    key: '5',
    labelKey: 'reports:tabs.salesByUser',
    currentAccess: 'financial',
    backendGate: 'financialReports',
    endpoint: '/reports/sales-by-user',
    exposesFinancialFields: true,
  },
  {
    id: REPORTS_TAB_IDS.atRiskOrders,
    key: '6',
    labelKey: 'reports:tabs.atRiskOrders',
    currentAccess: 'financial',
    backendGate: 'financialReports',
    endpoint: '/reports/at-risk-orders',
    exposesFinancialFields: true,
  },
  {
    id: REPORTS_TAB_IDS.settlements,
    key: '7',
    labelKey: 'reports:tabs.settlements',
    currentAccess: 'financial',
    backendGate: 'financialReports',
    endpoint: '/reports/settlements',
    exposesFinancialFields: true,
  },
];

export function getReportsTabDefinition(id: ReportsTabId): ReportsTabDefinition {
  const definition = REPORTS_TAB_DEFINITIONS.find((tab) => tab.id === id);

  if (!definition) {
    throw new Error(`Unknown reports tab: ${id}`);
  }

  return definition;
}
